import type { AuditTranslations } from "../interfaces/audit";

export const auditTranslations: AuditTranslations = {
  page_title: "Audit",
  page_subtitle: "Query and filter audit records by flow, action and dates.",
  button_refresh: "Refresh",
  page_loading: "Loading audit records...",

  filters_heading: "Filters",
  filters_label_flujo: "Flow",
  filters_label_accion: "Action",
  filters_label_date_start: "Start date",
  filters_label_date_end: "End date",
  filters_placeholder_flujo: "Select flow",
  filters_placeholder_accion: "Select action",
  filters_label_search: "Search by reference",
  filters_placeholder_search: "Search audit records...",
  filters_label_client: "Subclients",
  filters_placeholder_client: "Search subclients…",
  filters_label_organization: "Clients",
  filters_placeholder_organization: "Search clients…",
  filters_dropdown_empty: "No results",
  filters_hint: 'Filters will be applied to the API when you click "Apply Filters"',
  filters_button_apply: "Apply Filters",
  filters_button_clear: "Clear Filters",
  filters_label_amount_min: "Minimum amount",
  filters_label_amount_max: "Maximum amount",
  filters_placeholder_amount_min: "e.g. 0",
  filters_placeholder_amount_max: "e.g. 1000000",

  filter_flujo_note: "Note",
  filter_flujo_payment_confirmation: "Payment confirmation",
  filter_flujo_payment: "Payment",
  filter_flujo_shipping_quote: "Shipping quote",
  filter_flujo_public_account: "Public account",

  flujo_pago: "Payment",
  flujo_confirmacion: "Confirmation",
  flujo_nota: "Notes",

  accion_cambio_estado: "Status change",
  accion_actualizacion_datos: "Data update",
  accion_creacion: "Creation",
  accion_eliminacion: "Deletion",

  table_showing_one: "Showing 1 record on this page (Total: {{total}})",
  table_showing_many: "Showing {{count}} records on this page (Total: {{total}})",
  table_show_label: "Show:",
  table_th_date: "Date",
  table_th_reference_code: "Reference code",
  table_th_flujo: "Flow",
  table_th_client: "Client",
  table_th_currency: "Currency",
  table_th_amount: "Amount",
  table_th_accion: "Action",
  table_th_estado: "Status",
  table_estado_filed: "COMPLETED",
  table_th_created_by: "Created by",
  table_th_taken_by: "Taken by",
  table_th_archivos: "Files",
  table_th_actions: "Actions",
  table_empty: "No records to display.",
  table_button_view_history: "View history",
  table_tooltip_view_archivos: "View files",

  pagination_records: "Records {{from}} to {{to}} of {{total}}",
  pagination_total_pages: "Total pages ({{lastPage}})",
  pagination_first_page: "First page",
  pagination_prev_page: "Previous page",
  pagination_next_page: "Next page",
  pagination_last_page: "Last page",

  modal_title: "Entity history",
  modal_close_aria: "Close",
  modal_loading: "Loading history…",
  modal_error_load: "Could not load history.",
  modal_empty: "No records in history.",
  modal_section_title: "Change history",
  modal_duration: "Duration",
  modal_initial_status: "Initial status",
  modal_current_status: "Current status",
  modal_previous_status: "Previous status",
  modal_close_button: "Close",

  modal_action_create: "Creation",
  modal_action_update: "Data update",
  modal_action_delete: "Deletion",
  modal_action_status_change: "Status change",
  modal_action_restore: "Restoration",
  modal_action_view: "View",
  modal_action_take: "Taken",
  modal_action_release: "Released",

  modal_status_pending: "Pending",
  modal_status_in_progress: "In progress",
  modal_status_paid: "Paid",
  modal_status_confirmed: "Confirmed",
  modal_status_cancelled: "Cancelled",
  modal_status_archived: "Archived",
  modal_status_filed: "Filed",

  modal_archivos_no_comprobantes_note: "Voucher display coming soon",
  modal_archivos_no_comprobantes_payment_creation: "There are no vouchers to display at this time.",
  modal_archivos_no_comprobantes_default: "No vouchers to display",
  modal_archivos_deletion_note_label: "Cancellation reason",
  modal_archivos_confirmation_source_label: "Bank income",
  modal_archivos_payment_source_label: "Bank exit",

  tab_audit_general: "Payment confirmation requests",
  tab_payments: "Payment requests",

  payments_loading: "Loading payment records...",
  payments_filters_heading: "Payment Request Filters",
  payments_filters_label_org_name: "Client name",
  payments_filters_placeholder_org_name: "e.g. Company ABC",
  payments_filters_label_client_name: "Subclient name",
  payments_filters_placeholder_client_name: "e.g. John Doe",
  payments_filters_hint: 'Filters will be applied to the API when you click "Apply Filters"',
  payments_table_empty: "No payment records to display.",
  payments_table_th_client: "Client",
  payments_table_th_subclient: "Subclient",
  payments_table_showing_one: "Showing 1 record on this page (Total: {{total}})",
  payments_table_showing_many: "Showing {{count}} records on this page (Total: {{total}})",
  payments_filters_type_to_search: "Type to search...",
  payments_filters_label_payment_source: "Bank Exit",
  payments_filters_placeholder_payment_source: "Select bank exit",
  filters_label_confirmation_source: "Bank Income",
  filters_placeholder_confirmation_source: "Select bank income",

  tab_verification: "Verification requests",
  verification_filters_heading: "Search verification requests",
  verification_label_org_email: "Client email",
  verification_placeholder_org_email: "e.g. client@company.com",
  verification_label_client_email: "Subclient email",
  verification_placeholder_client_email: "e.g. subclient@email.com",
  verification_filters_hint: "Enter an email to perform the search. Only one field can be used at a time",
  verification_loading: "Searching verification requests...",
  verification_results_title: "Verification URLs found",
  verification_type_organization: "Client",
  verification_type_client: "Subclient",
  verification_empty: "No verification URLs found for the entered criteria.",
  verification_btn_copy: "Copy",
  verification_status_active: "Active",
  verification_status_used: "Used",
  verification_status_expired: "Expired",
  verification_error_org_not_found: "No client found with the entered email",
  verification_error_client_not_found: "No subclient found with the entered email",
};
